import type { Delta, Op } from 'quill/core';

const isInlineTextInsertion = ({ ops }: Delta) => {
  const isInlineTextInsertionOp = (op: Op) =>
    typeof op.insert === 'string' && !op.insert.includes('\n');

  if (ops.length > 2) return false;

  const [firstOp, secondOp] = ops;
  if (!firstOp) return true;
  if (!secondOp) return isInlineTextInsertionOp(firstOp);

  return (
    typeof firstOp.retain === 'number' &&
    !firstOp.attributes &&
    isInlineTextInsertionOp(secondOp)
  );
};

export default isInlineTextInsertion;
